<div class="justify-content-center">
  <div class="row">
    <div class="col-md-4 offset-md-4 card">
      <div class="card-header clearfix text-center fs-5 m-4">
        {{ app.text.exportData.description }}
      </div>
      <div class="mt-3 form-container">
        <form class="form">
          <div class="mb-3 checkbox-content">
            <input
              id="parts"
              value="part"
              type="checkbox"
              class="lg-checkbox"
              (change)="onCheckboxChange($event)"
            />
            <label for="parts" class="ps-2">{{
              app.text.exportData.parts
            }}</label>
          </div>
          <div class="mb-3 checkbox-content">
            <input
              id="manufacturers"
              value="manufacturer"
              type="checkbox"
              class="lg-checkbox"
              (change)="onCheckboxChange($event)"
            />
            <label for="manufacturers" class="ps-2">{{
              app.text.exportData.maunfacturers
            }}</label>
          </div>
          <div class="mb-3 checkbox-content">
            <input
              id="alerts"
              value="alert"
              type="checkbox"
              class="lg-checkbox"
              (change)="onCheckboxChange($event)"
            />
            <label for="alerts" class="ps-2">{{
              app.text.exportData.alerts
            }}</label>
          </div>
          <div class="mb-3 checkbox-content">
            <input
              id="messages"
              value="message"
              type="checkbox"
              class="lg-checkbox"
              (change)="onCheckboxChange($event)"
            />
            <label for="messages" class="ps-2">{{
              app.text.exportData.messages
            }}</label>
          </div>
          <a
            class="btn btn-blue p-2 mt-4"
            href="#"
            (click)="exportData($event)"
          >
            <span class="btn-blue-text">{{ app.text.exportData.export }}</span>
          </a>
        </form>
      </div>
    </div>
  </div>
</div>
